/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import s from './returnsHelpTooltip.module.css';

const ReturnsHelpTooltip = ({ titleText, helpText }) => {
  const [showHelpText, setShowHelpText] = React.useState(false);
  return (
    <div>
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          setShowHelpText(!showHelpText);
        }}
        className={s.help_text_title}
        aria-expanded={!!showHelpText}
        aria-controls="orderNumberHelp"
        role="button"
        onContextMenu={(e) => e.preventDefault()}
      >
        {titleText}
      </a>
      {showHelpText && (
        <div
          dangerouslySetInnerHTML={{ __html: helpText }}
          className={s.help_text_description}
          id="orderNumberHelp"
        />
      )}
    </div>
  );
};

ReturnsHelpTooltip.defaultProps = {
  titleText: '',
  helpText: '',
};

ReturnsHelpTooltip.propTypes = {
  titleText: PropTypes.string,
  helpText: PropTypes.string,
};

export default ReturnsHelpTooltip;
